// This is required to direct webpack toward your CSS - do not remove it.
import "../css/main.css";
import '../js/careers-search.js';
import '../js/careers-search-temp.js';

// This console.log is simply here to demonstrate the use of the baseURL
// variable, which is defined in each HTML file. You should remove it before
// publishing your bundle; if you don't need this variable, you can, and
// should, remove it from your HTML files, too.
//
// Note that in dev, this will always have a value of "/bundle". However, it
// will have a dynamic value when your bundle is deployed.
//
// This JS will execute at the end of every page that your custom experience
// component is referenced from. Be careful that you correctly scope your JS to
// your component.



// WEBPACK FOOTER //
// ./js/main.js